import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const cases = [{
  src: 'https://cdn.magicpatterns.com/uploads/ereak512gvEMCtbCQi3gDP/PinDown.io_carlo_ferrazzi_1776186916.jpg',
  caption: 'Ventanas de aluminio con DVH — Línea A30'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3DArpiAdmGuwfj5YcyrXuV/PinDown.io_kefrenpty_1776186471.jpg',
  caption: 'Ventana oscilobatiente — Terminación premium'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/96YT9urMZx1AG5nzNhfe1Z/PinDown.io_laurentroost18_1776187027.jpg',
  caption: 'Puerta balcón doble hoja — Línea Módena'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8HSpPe7u3FshD3a5cr9QiX/PinDown.io_windowworld13_1776186949.jpg',
  caption: 'Puerta de aluminio negro — Diseño moderno'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9SjjyVtSBJc6RtKhjw2WoD/PinDown.io_MirrorLineNeon_1776187426.jpg',
  caption: 'Cerramiento de galería — Paños fijos corredizos'
}];
export function CasesCarousel() {
  const [current, setCurrent] = useState(0);
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % cases.length);
  }, []);
  const prev = useCallback(() => {
    setCurrent(prev => (prev - 1 + cases.length) % cases.length);
  }, []);
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);
  return <section className="py-10 bg-gray-50 border-y border-gray-200" data-id="element-9">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-10">
        <div className="text-center mb-6" data-id="element-11">
          <h3 className="text-2xl md:text-3xl font-black text-matte mb-1" data-id="element-12">
            Casos reales de carpintería en aluminio
          </h3>
          <p className="text-sm text-gray-500 font-medium" data-id="element-13">
            Esto es lo que vas a poder fabricar con el sistema
          </p>
        </div>

        <div className="relative" data-id="element-14">
          {/* Main Image */}
          <div className="relative aspect-[4/3] md:aspect-video bg-matte overflow-hidden shadow-xl border border-gray-200" data-id="element-15">
            <AnimatePresence mode="wait" data-id="element-16">
              <motion.img key={current} src={cases[current].src} alt={cases[current].caption} initial={{
              opacity: 0,
              scale: 1.05
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.4
            }} className="w-full h-full object-cover" data-id="element-17" />
            </AnimatePresence>

            {/* Caption overlay */}
            <div className="absolute bottom-0 left-0 right-0 bg-matte/80 backdrop-blur-sm px-4 py-3" data-id="element-18">
              <p className="text-white font-bold text-sm md:text-base text-center" data-id="element-19">
                {cases[current].caption}
              </p>
            </div>

            {/* Nav arrows */}
            <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-matte/60 hover:bg-matte/80 text-white p-2 transition-colors" aria-label="Anterior" data-id="element-20">
              <ChevronLeft className="w-5 h-5" data-id="element-21" />
            </button>
            <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 bg-matte/60 hover:bg-matte/80 text-white p-2 transition-colors" aria-label="Siguiente" data-id="element-22">
              <ChevronRight className="w-5 h-5" data-id="element-23" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-24">
            {cases.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${i === current ? 'bg-gold w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Imagen ${i + 1}`} data-id="element-25" />)}
          </div>

          {/* Thumbnails */}
          <div className="flex gap-2 mt-4 overflow-x-auto pb-1" data-id="element-26">
            {cases.map((c, i) => <button key={i} onClick={() => setCurrent(i)} className={`flex-shrink-0 w-20 h-16 md:w-24 md:h-18 overflow-hidden border-2 transition-all ${i === current ? 'border-gold shadow-md' : 'border-transparent opacity-60 hover:opacity-80'}`} data-id="element-27">
                <img src={c.src} alt={c.caption} className="w-full h-full object-cover" data-id="element-28" />
              </button>)}
          </div>
        </div>
      </div>
    </section>;
}